import React, { forwardRef, memo } from 'react'

const AwardIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="120.4"
      height="140"
      viewBox="0 0 172 200"
      fill="none"
      {...props}>
      <path
        d="M75.457 58.44V23.018c0-8.988 7.287-16.275 16.275-16.275s16.275 7.287 16.275 16.275V58.44"
        stroke="#78BE20"
        strokeWidth="1.915"
      />
      <path
        d="M6.068 192.468 28.547 41.207h103.393l33.507 151.261H6.068Z"
        fill="#CEDC00"
      />
      <path
        d="m136.727 192.47-11.488-151.26h6.701l33.507 151.261h-28.72Z"
        fill="#78BE20"
      />
      <path
        d="M111.836 125.454H33.334l41.473-36.379 37.029 36.379Z"
        fill="#fff"
      />
      <path
        d="M54.396 52.697V17.275c0-8.988 7.286-16.275 16.274-16.275S86.945 8.287 86.945 17.275v35.422"
        stroke="#78BE20"
        strokeWidth="1.915"
      />
    </svg>
  )
)

AwardIcon.displayName = 'AwardIcon'

export default memo(AwardIcon)
